/**
 * @fileoverview Marcador durável "swipe-linked" — este APARELHO já teve uma
 * conta Swipe vinculada (pareamento aprovado / login) em algum momento.
 *
 * PARA QUE SERVE: quando a sessão Swipe CAI (401 do refresh, unrecoverable) o
 * cliente limpa a sessão (`clearSwipeSession`) e o usuário volta ao gate. Sem
 * este marcador, o gate não sabe distinguir "aparelho novo, nunca vinculou" de
 * "já era um usuário e a sessão caiu" — e mostra o gate FRIO de 1ª vez pros dois.
 * Com o marcador, o gate mostra a variante "reconecte sua conta" (mais acolhedor
 * e honesto: nada foi perdido, é só re-parear).
 *
 * É **UX-ONLY**. NUNCA é identidade nem escopo de autorização: não vira
 * `swipeUserId`, não habilita nenhuma leitura de sync, não bypassa a exigência de
 * token. Só decide a COPY do gate. (Invariante do cybersec.)
 *
 * POR-DEVICE (não por-conta), igual `welcome-flag`. Múltiplas contas/perfis no
 * mesmo aparelho compartilham o marcador — ele diz "este aparelho já foi de
 * alguém logado", não QUEM.
 *
 * DURABILIDADE (o ponto todo): sobrevive DE PROPÓSITO ao `clearSwipeSession`
 * (a limpeza recuperável do 401 vive em OUTRA chave, `iptv:swipe-session`). Só é
 * apagado no caminho TERMINAL/explícito: `signOut()` (sign-out.ts) e o Hard Reset
 * (`localStorage.clear()`). Se ele fosse limpo junto da sessão no 401, a variante
 * "reconecte" nunca apareceria — que é justamente o bug que este marcador fecha.
 */

const KEY = 'iptv:swipe-linked'

/** Este aparelho já vinculou uma conta Swipe alguma vez? (UX do gate, só isso.) */
export function wasSwipeLinked(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true'
  } catch {
    // Privacy mode / quota / plataforma sem suporte: assume que NÃO vinculou
    // (cai no gate frio). Degrada a copy, nunca quebra o boot.
    return false
  }
}

/** Marca o vínculo (chamado no pareamento/login aprovado E persistido). */
export function markSwipeLinked(): void {
  try {
    localStorage.setItem(KEY, 'true')
  } catch {
    // Falha silenciosa — o gate cai na copy fria no próximo boot. UX degradada,
    // não quebrada. (Não é caminho de segurança: perder o marcador nunca vaza
    // nada, só troca a copy.)
  }
}

/** Apaga o marcador — SÓ no sign-out terminal/explícito. NÃO chamar no 401
 *  recuperável (é justamente o que precisa sobreviver lá). */
export function clearSwipeLinked(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // idem
  }
}
